import React from 'react';
import { connect } from 'react-redux';
import {
    Grid,
    Select,
    MenuItem,
    Checkbox,
    FormControlLabel,
    FormControl,
    InputLabel,
    Typography
} from '@mui/material';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { setChartInterval, setChartTheme } from '../actions/settings';

const ChartSettings = ({ interval, darkMode, setChartInterval, setChartTheme }) => {
    const intervalList = ['D', 'W', 'M'];

    const handleIntervalChange = (e) => {
        setChartInterval(e.target.value);
    };

    const handleThemeChange = (e) => {
        setChartTheme(e.target.checked);
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl variant="filled" size="small" fullWidth>
                        <InputLabel>Interval</InputLabel>
                        <Select
                            value={interval}
                            onChange={handleIntervalChange}
                            label="Interval"
                        >
                            {intervalList.map((item) => (
                                <MenuItem key={item} value={item}>{item}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        sx={{ color: 'black' }}
                        control={
                            <Checkbox
                                size="small"
                                icon={<RadioButtonUncheckedIcon fontSize="small" />}
                                checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
                                checked={darkMode}
                                onChange={handleThemeChange}
                            />
                        }
                        label="Dark Mode"
                    />
                </Grid>
            </Grid>
        </>
    );
};

const mapStateToProps = (state) => ({
    interval: state.settings.interval,
    darkMode: state.settings.darkMode,
});

export default connect(mapStateToProps, { setChartInterval, setChartTheme })(ChartSettings);
